const accomodationTypes: { key: string; value: string; text: string }[] = [
  { key: '-AL-', value: '-AL-', text: 'Alberghi' }, // art. 6 L.R. 16/2004
  { key: '-CP-', value: '-CP-', text: 'Campeggi' }, // art. 6 L.R. 16/2004
  { key: '-VI-', value: '-VI-', text: 'Villaggi turistici' }, // art. 6 L.R. 16/2004
  { key: '-CF-', value: '-CF-', text: 'Case per ferie' }, // art. 7 L.R. 16/2004
  { key: '-OS-', value: '-OS-', text: 'Ostelli' }, // art. 8 L.R. 16/2004
  { key: '-RA-', value: '-RA-', text: 'Rifugi alpini' }, // art. 9 L.R. 16/2004
  { key: '-RE-', value: '-RE-', text: 'Rifugi escursionistici' }, // art. 9 L.R. 16/2004
  { key: '-AF-', value: '-AF-', text: 'Affittacamere' }, // art. 10 L.R. 16/2004
  { key: '-CV-', value: '-CV-', text: 'Case/App. vacanze' }, // art. 11 L.R. 16/2004
  {
    key: '-AT-',
    value: '-AT-',
    text: 'Appartamenti ammobiliati per uso turistico',
  }, // art. 12 L.R. 16/2004
  { key: '-BB-', value: '-BB-', text: 'Bed & Breakfast' }, // art. 13 L.R. 16/2004
  { key: '-AS-', value: '-AS-', text: 'Aree attrezzate di sosta temporanea' },
  { key: '-AG-', value: '-AG-', text: 'Agriturismi' },
];

const toOption = (text: string) => ({ key: text, value: text, text });

const categorie: Record<
  string,
  { key: string; value: string; text: string }[]
> = {
  '-AL-': [
    '1 Stella',
    '2 Stelle',
    '3 Stelle',
    '3 Stelle Superior',
    '4 Stelle',
    '4 Stelle Superior',
    '5 Stelle',
    '5 Stelle Lusso',
  ].map(toOption),
  '-CP-': ['1 Stella', '2 Stelle', '3 Stelle', '4 Stelle', '5 Stelle'].map(
    toOption,
  ),
  '-VI-': ['1 Stella', '2 Stelle', '3 Stelle', '4 Stelle', '5 Stelle'].map(
    toOption,
  ),
  '-AG-': [
    '1 Girasole',
    '2 Girasoli',
    '3 Girasoli',
    '4 Girasoli',
    '5 Girasoli',
  ].map(toOption),
  '-AT-': ['2 Soli', '3 Soli'].map(toOption),
  '-CV-': ['1 Sole', '2 Soli', '3 Soli', '4 Soli'].map(toOption),
  Affittacamere: [],
  '-BB-': [],
  Ostello: [],
  '-AS-': [],
};

const EMOJI_BY_UNIT: Record<string, string> = {
  Stella: '⭐️',
  Stelle: '⭐️',
  Girasole: '🌻',
  Girasoli: '🌻',
  Sole: '☀️',
  Soli: '☀️',
};

const SUFFIX_CODE_BY_NAME: Record<string, string> = {
  Superior: 'S',
  Lusso: 'L',
};

const toEmoji = (label: string): string => {
  const [count, unit, suffix] = label.split(' ');
  const emoji = EMOJI_BY_UNIT[unit] ?? '';
  const suffixCode = suffix ? SUFFIX_CODE_BY_NAME[suffix] ?? '' : '';
  return emoji.repeat(parseInt(count, 10)) + suffixCode;
};

const categorieView: Record<string, string> = Object.fromEntries(
  Array.from(
    new Set(
      Object.values(categorie)
        .flat()
        .map(({ text }) => text),
    ),
  ).map((text) => [text, toEmoji(text)]),
);

export { accomodationTypes, categorie, categorieView };
